// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-colors[data-v-33a8bb06]{opacity:0}.color-label[data-v-33a8bb06]:before,.input-colors[data-v-33a8bb06]{height:3.4rem;position:absolute;width:3.4rem}.color-label[data-v-33a8bb06]:before{content:\"\";display:inline}.color-label-checked[data-v-33a8bb06]:after{background:inherit}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
